import Md5 from '@/public/utils/md5.js'
import store from '@/store/index'
import { authorityTemplate } from '@/public/constant/template.js'
export default {
  // 获取权限
  AuthorityFilter(path) {
    let authority = JSON.parse(JSON.stringify(authorityTemplate))

    let menu = JSON.parse(JSON.stringify(store.state.menulist))

    for (let item of menu) {
      for (let subItem of item.children) {
        if (subItem.children) {
          for (let i of subItem.children) {
            let md5Path = i.md5Path
            if (!md5Path) {
              md5Path = Md5.md5(i.path + i.menuArgs)
              i.md5Path = md5Path
            }
            if ('/' + md5Path === path) {
              authority.see = i.seeType > 0
              authority.seeType = i.seeType
              authority.alEffectCondition = i.alEffectCondition
              authority.edit = i.edit > 0
              authority.special = i.special
              authority.showMoney = i.edit > 0
              authority.autoCode = i.ifAutoNum === '是'
              for (let special of i.special) {
                if (special.name === 'showMoney') {
                  authority.showMoney = true
                }
              }
              return authority
            }
          }
        } else {
          let md5Path = subItem.md5Path
          if (!md5Path) {
            md5Path = Md5.md5(subItem.path + subItem.menuArgs)
            subItem.md5Path = md5Path
          }
          if ('/' + md5Path === path) {
            authority.see = subItem.seeType > 0
            authority.seeType = subItem.seeType
            authority.alEffectCondition = subItem.alEffectCondition
            authority.edit = subItem.edit > 0
            authority.special = subItem.special
            authority.showMoney = subItem.edit > 0
            for (let special of subItem.special) {
              if (special.name === 'showMoney') {
                authority.showMoney = true
              }
            }
            return authority
          }
        }
      }
    }

    return authority
  },
}